export const ASSISTANT_CHAT_URL_OVERRIDE_KEY = 'omnetic.aiAssistant.streamUrl';
